/**
 * 28 spec Radius トークン
 *
 * 一次情報: docs/design-system/03_ui_implementation_spec.md §1.3
 */
export const RADIUS = {
  none: 0,
  sm: 4, // 小さなチップ・タグ
  md: 6, // ボタン・入力欄 (デフォルト = MUI shape.borderRadius)
  lg: 8, // サイドバーピル・ポップオーバー項目
  xl: 12, // モーダル・大きなカード・meeting block
  full: 9999, // ピル状 CTA
} as const
